export type FormFields = {
  name?: string;
  street?: string;
  address?: string;
  city?: string;
  state?: string;
  pincode?: string;
  phone?: string;
};

export type FormErrors = Partial<Record<keyof FormFields, string>>;

export const validateForm = (form: FormFields,
  t: (key: string) => string
): FormErrors => {
  const errs: FormErrors = {};

  if ("name" in form && !form.name?.trim()) errs.name = t("fields.nameRequired");

  if ("street" in form && !form.street?.trim()) errs.street = t("fields.addressRequired");
  if ("address" in form && !form.address?.trim()) errs.address = t("fields.addressRequired");

  if ("city" in form && !form.city?.trim()) errs.city = t("fields.cityRequired");
  if ("state" in form && !form.state?.trim()) errs.state = t("fields.stateRequired");

  if ("pincode" in form) {
    const pincodeVal = form.pincode?.trim() || "";
    if (!form.pincode?.trim()) {
      errs.pincode = t("fields.pincodeRequired");
    } else if (!/^\d+$/.test(form.pincode)) {
      errs.pincode = t("fields.onlyNumbersAllowed");
    } else if (pincodeVal.length < 4 || pincodeVal.length > 10) {
      errs.pincode = t("fields.pincodeLength");
    }
  }

  if ("phone" in form) {
    const phoneVal = form.phone?.trim() || "";
    if (!phoneVal) {
      errs.phone = t("fields.phoneRequired");
    } else if (phoneVal.length !== 10) {
      errs.phone = t("fields.phoneLength");
    } else if (!/^[6-9]/.test(phoneVal)) {
      errs.phone = t("fields.phoneInvalid");
    }
  }

  return errs;
};